import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from '@app/main/activities/services/activity.service';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AllDashboardServiceProxy, CalculationTimeAndAttendanceDto, TimeAndAttendanceServiceProxy } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-productivity-bar',
  templateUrl: './productivity-bar.component.html',
  styleUrls: ['./productivity-bar.component.css']
})
export class ProductivityBarComponent implements OnInit,OnDestroy {
    isDashboard: string = 'Dashboard';
    userStats: CalculationTimeAndAttendanceDto;
    productivityPercentage: number;


    constructor(private _monitorService:MonitoringService,private _AllDashboardServiceProxy: AllDashboardServiceProxy,private _activityService: ActivityService,private cdRef:ChangeDetectorRef,private _timeAndAttend:TimeAndAttendanceServiceProxy) { }
  ProductiveBarStartTime;
  ProductiveBarEndTime;
  dateTime = new Date();
  //date = new Date();
  ngOnInit(): void {
    this.getTenantId();
    this.getUserId();
    let date = new Date();
    localStorage.setItem('dashboardProductivity', this.isDashboard);
    // setTimeout(() => {
        this.getUserArrivalTime(date);
    // }, 2000);
    
    // To remove duplicate API call of GetUserTimeCalculation()

    // this._AllDashboardServiceProxy
    //     .getUserTimeCalculation(abp.session.userId, abp.session.tenantId, DateTime.fromJSDate(this.setZeroTimeForLocalDate(date)))
    //     .subscribe((result) => {
    //        // this.userStats = result;
    //        console.log(result, "111");
    //        console.log(JSON.stringify(result), "222");
    //         this.ProductiveBarStartTime = this.getArrivalTime(result.arrivalTime)?.getHours();
    //         // console.log(typeof result.arrivalTime, result.arrivalTime, "666");
            
    //         if(this.ProductiveBarStartTime !=undefined){
    //             if(this.ProductiveBarStartTime>9){
    //                 this.ProductiveBarStartTime =9;
    //             }
    //           //  this.ProductiveBarEndTime = this.ProductiveBarStartTime + result.inTimeProsTime

    //         }
    //         if(this.ProductiveBarStartTime== undefined){
    //             this.ProductiveBarStartTime = 9;
    //         }
            
    //     });

    this._activityService.selectView('day', date);
    }

    getUserArrivalTime(date) {
        try{
            this._monitorService.logTrace("UI-getUserArrivalTime", { "getUserArrivalTime ": "getProductiviyBarStartTime:called " + this + this.dateTime })
            this.ProductiveBarStartTime = -1;
            this.ProductiveBarEndTime = -1;
            this.userStats = undefined;
            date.setHours(0, 0, 0, 0);
            let d = new Date();
            this._timeAndAttend.getUserCalculationBaseOnActivity(abp.session.userId, abp.session.tenantId, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), d.getTimezoneOffset(), DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(d)), DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), undefined).subscribe(
                result => {
                    this.productivityPercentage = result.productivityPercentage;
                    abp.event.trigger('passDataToUserInfoSection', result);
                    this.cdRef.detectChanges();
                    var d = new Date();
                    this.userStats = result;
                    let t1 = this._activityService.setZeroTimeForLocalDate(date);
                    let t2 = this._activityService.setZeroTimeForLocalDate(d);
                    if (t1.getDate() == t2.getDate() && t1.getMonth() == t2.getMonth() && t1.getFullYear() == t2.getFullYear()) {
                        if (result.isPRodTimePresent) {
                            this.ProductiveBarStartTime = this.getArrivalTime(result.productivityBarStartTime)?.getHours();
                            if (this.ProductiveBarStartTime != undefined) {
                                if (this.ProductiveBarStartTime > 9) {
                                    this.ProductiveBarStartTime = 9;
                                }
                                //this.ProductiveBarStartTime =0;
                                let currDate = new Date();
                                let currenthours = currDate.getHours() + 1;
                                let diff = currenthours - this.ProductiveBarStartTime;

                                if (diff < 11) {
                                    this.ProductiveBarEndTime = this.ProductiveBarStartTime + 12;
                                } else {
                                    this.ProductiveBarEndTime = this.ProductiveBarStartTime + diff;
                                }
                                //  this.ProductiveBarEndTime = 12;   
                            }
                            if (this.ProductiveBarStartTime == undefined) {
                                this.ProductiveBarStartTime = 9;
                                this.ProductiveBarEndTime = 21;
                            }
                        }
                        else {
                            this.ProductiveBarStartTime = 9;
                            this.ProductiveBarEndTime = 21;
                        }
                    }
                    else {
                        this.ProductiveBarStartTime = 0;
                        this.ProductiveBarEndTime = 24;
                    }
                    this.cdRef.detectChanges();
                    // });
                });

   
    }
    catch(ex:any){
        this._monitorService.logException(ex ,2);
      }
    }

    getUserId() {
        return abp.session.userId;
    }


    getTenantId() {
        return abp.session.tenantId;
    }

    setZeroTimeForLocalDate(date: Date): Date {
      date.setHours(0, 0, 0, 0);
      return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }
  getArrivalTime(date: DateTime) {
    if (date?.hour == 0 && date?.minute == 0) {
        return;
    }
    let jsDate = new Date(
        `${date?.year}-${date?.month < 10 ? "0" + date?.month : date?.month}-${date?.day < 10 ? "0" + date?.day : date?.day}T${
            date?.hour < 10 ? "0" + date?.hour : date?.hour
        }:${date?.minute < 10 ? "0" + date?.minute : date?.minute}:00`
    );
    return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    //console.log(date);
    /*  let jsDate = this.getLocalJsDate(date);
    //console.log(jsDate,"jsdate");
    let hours = jsDate.getHours() % 12;
    let min = jsDate.getMinutes();

    if (isNaN(hours) && isNaN(min)) {
        return '00:00';
    } else {
        return `${hours < 10 ? '0' + hours: hours}:${min < 10 ? '0' + min : min}`;
    }*/
    }

    ngOnDestroy() {
        localStorage.removeItem('dashboardProductivity');
    }
    RefreshProd(event: any) {
        this.getUserArrivalTime(new Date())
        // if (this.ProductiveBarStartTime > event) {
        //     this.ProductiveBarStartTime = event;
        //     let currDate = new Date();
        //     let currenthours = currDate.getHours() + 1;
        //     let diff = currenthours - this.ProductiveBarStartTime;

        //     if (diff < 11) {
        //         this.ProductiveBarEndTime = this.ProductiveBarStartTime + 12;
        //     } else {
        //         this.ProductiveBarEndTime = this.ProductiveBarStartTime + diff;
        //     }

        // }
        // this.cdRef.detectChanges();

    }

}
